<script setup>
import _ from 'lodash'
import {
  useConfigStore,
} from '@core/stores/config'
import {
  AppContentLayoutNav,
} from '@layouts/enums'
import {
  switchToVerticalNavOnLtOverlayNavBreakpoint,
} from '@layouts/utils'

const GuestLayoutWithHorizontalNav = defineAsyncComponent(() => import(
  './components/GuestLayoutWithHorizontalNav.vue'))

const GuestLayoutWithVerticalNav = defineAsyncComponent(() => import(
  './components/GuestLayoutWithVerticalNav.vue'))

const configStore = useConfigStore()
import SiteMessage from '@/components/share/message.vue'

// ℹ️ This will switch to vertical nav when define breakpoint is reached when in horizontal nav layout

// Remove below composable usage if you are not using horizontal nav layout in your app
switchToVerticalNavOnLtOverlayNavBreakpoint()

const {
  layoutAttrs,
  injectSkinClasses,
} = useSkins()

injectSkinClasses()

// Add noindex and nofollow meta tags
useHead({
  meta: [
    { name: 'robots', content: 'noindex, nofollow' },
  ],
})

async function onLoad() {}

// chagne the theme to light only
await onMounted(() => {
  configStore.theme = 'light'
  onLoad()
})

// chagne the theme to light only
</script>

<template>
  <div>
    <ClientOnly>
      <SiteMessage />
    </ClientOnly>
    <Component
      v-bind="layoutAttrs"
      :is="configStore.appContentLayoutNav === AppContentLayoutNav.Vertical ? GuestLayoutWithVerticalNav : GuestLayoutWithHorizontalNav"
    >
      <slot />
    </Component>
  </div>
</template>

<style lang="scss">
    // As we are using `layouts` plugin we need its styles to be imported
    @use "@layouts/styles/default-layout";
</style>